import { combineEpics, ofType } from 'redux-observable';
import { map, catchError, switchMap, debounceTime, takeUntil, tap, mergeMap, startWith } from 'rxjs/operators';
import { createErrorStream } from 'common/store/error';
import { addNotification, replaceNotification, removeNotification } from 'common/mdc/notifications/actions';
import { of } from 'rxjs';
import {
  TYPE_PENDING, TYPE_SUCCESS, TYPE_ERROR
} from 'common/mdc/notifications/notification';

import {
  LOAD, load,
  loadSuccess,
  loadError,
  download,
  downloadSuccess,
  downloadError,
  TOGGLE_SORT,
  PAGINATION_CHANGE,
  SEARCH,
  SET_SELECTED,
  ADVANCED_SEARCH,
  DUPLICATE_JOB_CHECK,
  duplicateJobCheckSuccess,
  duplicateJobCheckError,
  CLEAR,
  CHECK_FOR_METER_EXISTENCE,
  checkForMeterExistenceSuccess,
  checkForMeterExistenceError,
  runGetJob,
  RUN_GET_JOB,
  runGetJobSuccess,
  runGetJobError,
  showCreateJobDialog,
  showPreviewJobDialog,
} from './actions';

import {
  getStoreParams,
} from './selectors';

import {
  actions,
} from '../job';
import purgeEpic from './purgeEpic';


const loadEpic = (action, state, { jobService }) => action.pipe(
  ofType(LOAD),
  switchMap(action$ => jobService
    .getAll(getStoreParams(state.value))
    .pipe(
      map(loadSuccess),
      catchError(createErrorStream(action$, loadError)),
    )),
);

const update = action => action.pipe(
  ofType(TOGGLE_SORT, PAGINATION_CHANGE, ADVANCED_SEARCH),
  map(load),
);

const search = action => action.pipe(
  ofType(SEARCH),
  debounceTime(150),
  map(load),
);


const loadSelected = action => action.pipe(
  ofType(SET_SELECTED),
  map(({ selected }) => actions.load(selected.jobId)),
);

const duplicateJobCheckEpic = (action, state, { jobServiceWs }) => action.pipe(
  ofType(DUPLICATE_JOB_CHECK),
  switchMap(action$ => jobServiceWs
    .getJobByName(action$.jobName)
    .pipe(
      map(duplicateJobCheckSuccess),
      takeUntil(action.pipe(ofType(CLEAR))),
      catchError(error =>{
        action$.stepper && action$.stepper.resolve({});
        action$.saveStep1Details && action$.saveStep1Details(action$.jobDetails);
        return createErrorStream(
        action$,
        duplicateJobCheckError
      )(error)
    }),
    )),
);

const checkForMeterExistence = (action, state, { jobServiceWs }) => action.pipe(
  ofType(CHECK_FOR_METER_EXISTENCE),
  switchMap(action$ => jobServiceWs
    .checkForMeterExistence(action$.groupDetails)
    .pipe(
      tap(() => {
        action$.stepper && action$.stepper.resolve({});
        action$.saveStep2Details && action$.saveStep2Details(action$.groupDetails.meters);
      }),
      map(checkForMeterExistenceSuccess),
      takeUntil(action.pipe(ofType(CLEAR))),
      catchError(createErrorStream(
        action$,
        checkForMeterExistenceError
      )),
    )),
);

const runGetJobEpic = (action, state, { jobServiceWs }) => action.pipe(
  ofType(RUN_GET_JOB),
  mergeMap((action$) => {

    const pendingNotification = addNotification({
      autoHide: false,
      type: TYPE_PENDING,
      text: "Job creation is in progress."
    });
    const failureMessage = "Some error occured.";

    return jobServiceWs
    .runGetJob(action$.payload)
      .pipe(
        mergeMap((response) => of(
          replaceNotification(pendingNotification.notification, {
            type: TYPE_SUCCESS,
            autoHide: true,
            text: "The job has been created successfully and is currently being scheduled",
          }),
          runGetJobSuccess(response),
          load(),
          showCreateJobDialog(false),
          showPreviewJobDialog(false),
        )),
        startWith(pendingNotification),
        catchError(
          createErrorStream(action$, (err) =>
            replaceNotification(pendingNotification.notification, {
              autoHide: true,
              type: TYPE_ERROR,
              text: err.message ? err.message : failureMessage,
            })
          )
        )
      );
  }),
);

export default combineEpics(
  loadEpic,
  update,
  search,
  loadSelected,
  duplicateJobCheckEpic,
  checkForMeterExistence,
  runGetJobEpic,
);
